// const config = require('../../temp/config')

// graphql store values globally, used throughout the whole application
export let settings

export function setSettings(settingsList) {
  settings = settingsList
}
